import { ReactTooltipStyled } from "components/atoms/Tooltip/Tooltip.styled";
import { Small } from "utils/styling/typography.styled";
export const ReferTooltip = () => {
  return <ReactTooltipStyled id="referralTip" data-sentry-element="ReactTooltipStyled" data-sentry-component="ReferTooltip" data-sentry-source-file="index.tsx">
            <ul>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Refer a friend and earn 250 gold!</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">
                        When your friend makes a purchase of ANY gold amount or
                        a Subscription (not Basic), both you and your friend
                        receive 250 free gold.
                    </Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">
                        This reward is valid for the first purchase for each
                        friend you refer, but you can refer an unlimited number
                        of friends.
                    </Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">
                        Start referring and enjoy the benefits together!
                    </Small>
                </li>
            </ul>
        </ReactTooltipStyled>;
};